import script from "./newsInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./newsInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./newsInfoAdd.vue?vue&type=style&index=0&id=3f38a03e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f38a03e"]])

export default __exports__